import { IUser } from 'modules/models/user';
import { ClientModel, GeneralModel, ProjectNewModel, SearchModel } from '../../models';

export enum ActionType {
  FETCH_CLIENT_START = '[client] fetch client start',
  FETCH_SELF_COMPANY_START = '[client] fetch self company start',
  FETCH_SELF_COMPANY_SUCCESS = '[client] fetch self company success',
  SAVE_MERGE_COMPANY_START = '[client] save merge company start',
  SAVE_MERGE_COMPANY_SUCCESS = '[client] save merge company success',
  FETCH_MERGE_COMPANY_USERS_START = '[client] fetch merge company users start',
  FETCH_MERGE_COMPANY_USERS_SUCCESS = '[client] fetch merge company users success',
  CLEAR_MERGE_COMPANY_USERS = '[client] clear merge company users',
  FETCH_MERGE_COMPANY_INVOICES_SUMMARY_START = '[client] fetch merge company invoices summary start',
  FETCH_MERGE_COMPANY_INVOICES_SUMMARY_SUCCESS = '[client] fetch merge company invoices summary success',
  CLEAR_MERGE_COMPANY_INVOICES_SUMMARY = '[client] clear merge company invoices summary',

  FETCH_MERGE_COMPANY_REVIEW_INVOICES_SUMMARY_START = '[client] fetch merge company review invoices summary start',
  FETCH_MERGE_COMPANY_REVIEW_INVOICES_SUMMARY_SUCCESS = '[client] fetch merge company review invoices summary success',
  CLEAR_MERGE_COMPANY_REVIEW_INVOICES_SUMMARY = '[client] clear merge company review invoices summary',

  FETCH_MERGE_COMPANY_INVOICES_START = '[client] fetch merge company invoices start',
  FETCH_MERGE_COMPANY_INVOICES_SUCCESS = '[client] fetch merge company invoices success',
  CLEAR_MERGE_COMPANY_INVOICES = '[client] clear merge company invoices',

  FETCH_MERGE_COMPANY_WORKERS_START = '[client] fetch merge company workers start',
  FETCH_MERGE_COMPANY_WORKERS_SUCCESS = '[client] fetch merge company workers success',
  CLEAR_MERGE_COMPANY_WORKERS = '[client] clear merge company workers',
  FETCH_MERGE_COMPANY_BILLING_SUMMARY_START = '[client] fetch merge company billing summary start',
  FETCH_MERGE_COMPANY_BILLING_SUMMARY_SUCCESS = '[client] fetch merge company billing summary success',
  CLEAR_MERGE_COMPANY_BILLING_SUMMARY = '[client] clear merge company billing summary',
  FETCH_MERGE_COMPANY_SUMMARY_START = '[client] fetch merge company summary start',
  FETCH_MERGE_COMPANY_SUMMARY_SUCCESS = '[client] fetch merge company summary success',
  CLEAR_MERGE_COMPANY_SUMMARY = '[client] clear merge company summary',
  FETCH_MERGE_COMPANY_PROJECT_SUMMARY_START = '[client] fetch merge company project summary start',
  FETCH_MERGE_COMPANY_PROJECT_SUMMARY_SUCCESS = '[client] fetch merge company project summary success',
  CLEAR_MERGE_COMPANY_PROJECT_SUMMARY = '[client] clear merge company project summary',
  SAVE_SELECTED_MERGE_COMPANY_PROJECTS = '[client] save selected merge company projects',
  CLEAR_SELECTED_MERGE_COMPANY_PROJECTS = '[client] clear selected merge company projects',
  SAVE_SELECTED_MERGE_COMPANY_USERS = '[client] save selected merge company users',
  SAVE_SELECTED_MERGE_COMPANY_WORKERS = '[client] save selected merge company workers',
  SAVE_SELECTED_MERGE_COMPANY_INVOICES = '[client] save selected merge company invoices',
  CLEAR_SELECTED_MERGE_COMPANY_USERS = '[client] clear selected merge company users',
  CLEAR_SELECTED_MERGE_COMPANY_INVOICES = '[client] clear selected merge company invoices',
  CLEAR_SELECTED_MERGE_COMPANY_WORKERS = '[client] clear selected merge company workers',
  FETCH_DRAFT_CLIENT_START = '[client] fetch draft client start',
  FETCH_ONBOARDING_CLIENT_START = '[client] fetch onboarding client start',
  FETCH_CLIENT_SUCCESS = '[client] fetch client success',
  FETCH_CLIENT_LIST_SUCCESS = '[client] fetch client list success',
  FETCH_CLIENT_HIERARCHY_START = '[client] fetch client hierarchy start',
  FETCH_CLIENT_HIERARCHY_SUCCESS = '[client] fetch client hierarchy success',
  CLEAR_CLIENT_HIERARCHY = '[client] clear client hierarchy',
  UPDATE_CLIENT_HIERARCHY_START = '[client] update client hierarchy',
  FETCH_USER_CLIENTS_START = '[client] fetch user clients start',
  FETCH_USER_CLIENTS_SUCCESS = '[client] fetch user clients success',
  UNMARK_BRANCH_START = '[client] unmark branch',
  FETCH_CLIENT_BRANCHES_START = '[client] fetch client branches start',
  FETCH_CLIENT_BRANCHES_SUCCESS = '[client] fetch client branches success',
  CLEAR_CLIENT_BRANCHES = '[client] clear client branches',
  INVITE_COMPANY_AS_BRANCH_START = '[client] invite company as branch',
  FETCH_ONBOARDING_CLIENT_LIST_SUCCESS = '[client] fetch onboarding client list success',
  FETCH_CLIENT_LIST_START = '[client] fetch client list start',
  FETCH_CLIENT_SUMMARY_START = '[client] fetch client summary start',
  FETCH_SUBCONTRACTOR_LIST_START = '[client] fetch subcontractor list start',
  SAVE_CLIENT_START = '[client] save client start',
  SAVE_CLIENT_SUCCESS = '[client] save client success',
  INVITE_DRAFT_CLIENT_START = '[client] invite draft client start',
  INVITE_DRAFT_CLIENT_SUCCESS = '[client] invite draft client success',
  UPDATE_DRAFT_CLIENT_START = '[client] update draft client start',
  UPDATE_DRAFT_CLIENT_SUCCESS = '[client] update draft client success',
  SEND_FOR_APPROVE_CLIENT_START = '[client] send for approve client start',
  SEND_FOR_APPROVE_ONBOARDING_CLIENT_START = '[client] send for approve onboarding client start',
  APPROVE_CLIENT_START = '[client] approve client start',
  APPROVE_ONBOARDING_CLIENT_START = '[client] approve onboarding client start',
  FETCH_MWBE_START = '[client] fetch mbe/wbe start',
  FETCH_MWBE_SUCCESS = '[client] fetch mbe/wbe success',
  FETCH_TRADES_START = '[client] fetch trades start',
  FETCH_TRADES_SUCCESS = '[client] fetch trades success',
  FETCH_USER_CLIENT_LIST_START = '[client] user client list start',
  FILTER_START = '[client] filter start',
  FETCH_PROJECT_CLIENT_LIST_START = '[client] fetch project client list start',
  FETCH_PROJECT_CLIENT_LIST_SUCCESS = '[client] fetch project client list success',
  SEARCH_CLIENT_START = '[client] search client start',
  CLEAR_CLIENT_MAP = '[client] clear client map',
  CLEAR_ONBOARDING_CLIENT_MAP = '[client] clear onboarding client map',
  DELETE_CLIENT_START = '[client] delete client start',
  DELETE_ONBOARDING_CLIENT_START = '[client] delete onboarding client start',
  UPDATE_CLIENT_START = '[client] update client start',
  UPDATE_ONBOARDING_CLIENT_START = '[client] update onboarding client start',
  UPDATE_CLIENT_SUCCESS = '[client] update client success',
  UPDATE_ONBAORDING_CLIENT_SUCCESS = '[client] update onboarding client success',
  ARCHIVE_CLIENT_START = '[client] archive client start',
  ARCHIVE_CLIENT_SUCCESS = '[client] archive client success',
  UNARCHIVE_CLIENT_START = '[client] unarchive client start',
  UNARCHIVE_CLIENT_SUCCESS = '[client] unarchive client success',
  FETCH_PROJECT_CLIENT_HIREARCHY_LIST_START = '[client] fetch project client hirearchy list start',
  FETCH_PROJECT_CLIENT_HIREARCHY_LIST_SUCCESS = '[client] fetch project client hirearchy list success',
  FETCH_PROJECT_CLIENT_SUMMARY_START = '[client] fetch project client summary start',
  FETCH_PROJECT_CLIENT_SUMMARY_SUCCESS = '[client] fetch project client summary success',
  UPDATE_PROJECT_CLIENT_TAX_CONDITION_START = '[client] update project client tax condition start',
  UPDATE_PROJECT_CLIENT_TAX_CONDITION_SUCCESS = '[client] update project client tax condition success',
  FETCH_ADMIN_PERMISSION_START = '[client] fetch admin permission start',
  FETCH_ADMIN_PERMISSION_SUCCESS = '[client] fetch admin permission success',
  UPDATE_WELCOME_KIT_START = '[client] update welcome kit start',
  FETCH_CLIENT_DRAFT_SUMMARY_START = '[client] fetch client draft summary start',
  FETCH_PROJECT_COMPANY_START = '[client] fetch project company start',
  FETCH_PROJECT_COMPANY_SUCCESS = '[client] fetch project company success',
  UPDATE_PROJECT_COMPANY_START = '[client] update project company start',
  UPDATE_PROJECT_COMPANY_SUCCESS = '[client] update project company success',
  FETCH_JOINT_VENTURE_COMPANY_USERS_START = '[client] fetch joint venture company users start',
  FETCH_JOINT_VENTURE_COMPANY_USERS_SUCCESS = '[client] fetch joint venture company users success',
  FETCH_SEARCH_INVITE_CLIENT_START = '[client] fetch search invite client start',
  FETCH_SEARCH_INVITE_CLIENT_SUCCESS = '[client] fetch search invite client success',
  ASSIGN_CLIENT_PROJECT_START = '[client] assign client to project',
  ASSIGN_CLIENT_PROJECT_SUCCESS = '[client] assign client to project success',
  FETCH_FAILED_TRANSACTIONS_START = '[client] fetch failed transactions start',
  FETCH_FAILED_TRANSACTIONS_SUCCESS = '[client] fetch failed transactions success',
  VIEWED_FAILED_TRANSACTIONS = '[client] viewed failed transactions',
  FETCH_ALL_ACTIVE_CLIENTS_START = '[client] fetch all active clients start',
  FETCH_ALL_ACTIVE_CLIENTS_SUCCESS = '[client] fetch all active clients success',
  FETCH_CLIENT_LIST_FOR_MULTIPLE_PROJECTS_START = '[client] fetch client list for multiple projects start',
  FETCH_CLIENT_LIST_FOR_MULTIPLE_PROJECTS_SUCCESS = '[client] fetch client list for multiple projects success',
  ADD_UNVERIFIED_COMPANIES_START = '[projectNew] add unverified companies start',
  ADD_UNVERIFIED_COMPANIES_SUCCESS = '[projectNew] add unverified companies success',
  UPDATE_UNVERIFIED_COMPANY_SPONSOR_START = '[projectNew] update unverified company sponsor start',
  UPDATE_UNVERIFIED_COMPANY_SPONSOR_SUCCESS = '[projectNew] update unverified company sponsor success',
  UPDATE_PENDING_WELCOME_CLIENT_NOTES_START = '[client] update pending welcome client notes start',
}

export const actions = {
  fetchDraftClientStart: (id: string) => ({ type: ActionType.FETCH_DRAFT_CLIENT_START, payload: { id } }),
  fetchClientHierarchyStart: (id: string, query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_CLIENT_HIERARCHY_START,
    payload: { id, query },
  }),
  fetchClientHierarchySuccess: (data: Partial<ClientModel.IBranch>) => ({
    type: ActionType.FETCH_CLIENT_HIERARCHY_SUCCESS,
    payload: data,
  }),
  clearClientHierarchy: () => ({ type: ActionType.CLEAR_CLIENT_HIERARCHY, payload: {} }),
  updateClientHierarchyStart: (id: string, hierarchy: any) => ({
    type: ActionType.UPDATE_CLIENT_HIERARCHY_START,
    payload: { id, hierarchy },
  }),
  fetchUserClientsStart: (id: string, clientId: string, authResponse: any) => ({
    type: ActionType.FETCH_USER_CLIENTS_START,
    payload: { id, clientId, authResponse },
  }),
  fetchUserClientsSuccess: (list: GeneralModel.INamedEntity[]) => ({ type: ActionType.FETCH_USER_CLIENTS_SUCCESS, payload: { list } }),
  unmarkBranchStart: (id: string, hierarchy: any) => ({
    type: ActionType.UNMARK_BRANCH_START,
    payload: { id, hierarchy },
  }),
  fetchClientBranchesStart: (id: string, query: GeneralModel.IQueryParams) => ({ type: ActionType.FETCH_CLIENT_BRANCHES_START, payload: { id, query } }),
  fetchClientBranchesSuccess: (id: string, hierarchy: Partial<ClientModel.IBranch>) => ({
    type: ActionType.FETCH_CLIENT_BRANCHES_SUCCESS,
    payload: { id, hierarchy },
  }),
  clearClientBranches: () => ({ type: ActionType.CLEAR_CLIENT_BRANCHES, payload: {} }),
  inviteCompanyAsABranchStart: (id: string, hierarchy: any) => ({
    type: ActionType.INVITE_COMPANY_AS_BRANCH_START,
    payload: { id, hierarchy },
  }),

  fetchClientStart: (id: string) => ({ type: ActionType.FETCH_CLIENT_START, payload: { id } }),
  fetchMergeCompanySummaryStart: (id: string) => ({ type: ActionType.FETCH_MERGE_COMPANY_SUMMARY_START, payload: { id } }),
  fetchMergeCompanySummarySuccess: (id: string, summary: any) => ({
    type: ActionType.FETCH_MERGE_COMPANY_SUMMARY_SUCCESS,
    payload: { id, summary },
  }),
  clearMergeCompanySummary: () => ({
    type: ActionType.CLEAR_MERGE_COMPANY_SUMMARY,
  }),
  fetchMergeCompanyProjectSummaryStart: (id: string) => ({ type: ActionType.FETCH_MERGE_COMPANY_PROJECT_SUMMARY_START, payload: { id } }),
  fetchMergeCompanyProjectSummarySuccess: (id: string, projectSummary: any) => ({
    type: ActionType.FETCH_MERGE_COMPANY_PROJECT_SUMMARY_SUCCESS,
    payload: { id, projectSummary },
  }),
  clearMergeCompanyProjectSummary: () => ({
    type: ActionType.CLEAR_MERGE_COMPANY_PROJECT_SUMMARY,
  }),
  fetchMergeCompanyUserStart: (id: string) => ({ type: ActionType.FETCH_MERGE_COMPANY_USERS_START, payload: { id } }),
  fetchMergeCompanyUserSuccess: (id: string, users: any) => ({
    type: ActionType.FETCH_MERGE_COMPANY_USERS_SUCCESS,
    payload: { id, users },
  }),
  clearMergeCompanyUsers: () => ({
    type: ActionType.CLEAR_MERGE_COMPANY_USERS,
  }),
  fetchMergeCompanyBillingSummaryStart: (id: string) => ({ type: ActionType.FETCH_MERGE_COMPANY_BILLING_SUMMARY_START, payload: { id } }),
  fetchMergeCompanyBillingSummarySuccess: (id: string, billingSummary: any) => ({
    type: ActionType.FETCH_MERGE_COMPANY_BILLING_SUMMARY_SUCCESS,
    payload: { id, billingSummary },
  }),
  clearMergeCompanyBillingCompany: () => ({
    type: ActionType.CLEAR_MERGE_COMPANY_BILLING_SUMMARY,
  }),

  fetchMergeCompanyInvoicesSummaryStart: (id: string) => ({ type: ActionType.FETCH_MERGE_COMPANY_INVOICES_SUMMARY_START, payload: { id } }),
  fetchMergeCompanyInvoicesSummarySuccess: (id: string, invoicesSummary: any) => ({
    type: ActionType.FETCH_MERGE_COMPANY_INVOICES_SUMMARY_SUCCESS,
    payload: { id, invoicesSummary },
  }),
  clearMergeCompanyInvoicesSummary: () => ({
    type: ActionType.CLEAR_MERGE_COMPANY_INVOICES_SUMMARY,
  }),

  fetchMergeCompanyReviewInvoicesSummaryStart: (id: string, query: GeneralModel.IQueryParams) => ({ type: ActionType.FETCH_MERGE_COMPANY_REVIEW_INVOICES_SUMMARY_START, payload: { id, query } }),
  fetchMergeCompanyReviewInvoicesSummarySuccess: (id: string, reviewInvoicesSummary: any) => ({
    type: ActionType.FETCH_MERGE_COMPANY_REVIEW_INVOICES_SUMMARY_SUCCESS,
    payload: { id, reviewInvoicesSummary },
  }),
  clearMergeCompanyReviewInvoicesSummary: () => ({
    type: ActionType.CLEAR_MERGE_COMPANY_REVIEW_INVOICES_SUMMARY,
  }),

  fetchMergeCompanyInvoicesStart: (id: string) => ({ type: ActionType.FETCH_MERGE_COMPANY_INVOICES_START, payload: { id } }),
  fetchMergeCompanyInvoicesSuccess: (id: string, invoices: any) => ({
    type: ActionType.FETCH_MERGE_COMPANY_INVOICES_SUCCESS,
    payload: { id, invoices },
  }),
  clearMergeCompanyInvoices: () => ({
    type: ActionType.CLEAR_MERGE_COMPANY_INVOICES,
  }),

  fetchMergeCompanyWorkersStart: (id: string) => ({ type: ActionType.FETCH_MERGE_COMPANY_WORKERS_START, payload: { id } }),
  fetchMergeCompanyWorkersSuccess: (id: string, workersSummary: any) => ({
    type: ActionType.FETCH_MERGE_COMPANY_WORKERS_SUCCESS,
    payload: { id, workersSummary },
  }),
  clearMergeCompanyWorkers: () => ({
    type: ActionType.CLEAR_MERGE_COMPANY_WORKERS,
  }),
  saveMergeCompanyStart: (mergeCompany: any) => ({ type: ActionType.SAVE_MERGE_COMPANY_START, payload: { mergeCompany } }),
  saveMergeCompanySuccess: () => ({
    type: ActionType.SAVE_MERGE_COMPANY_SUCCESS,
    payload: {},
  }),
  saveSelectedMergeCompanyProjects: (selectedProjects: any) => ({
    type: ActionType.SAVE_SELECTED_MERGE_COMPANY_PROJECTS,
    payload: { selectedProjects },
  }),
  clearSelectedMergeCompanyProjects: () => ({
    type: ActionType.CLEAR_SELECTED_MERGE_COMPANY_PROJECTS,
  }),
  saveSelectedMergeCompanyUsers: (selectedUsers: any) => ({
    type: ActionType.SAVE_SELECTED_MERGE_COMPANY_USERS,
    payload: { selectedUsers },
  }),
  clearSelectedMergeCompanyUsers: () => ({
    type: ActionType.CLEAR_SELECTED_MERGE_COMPANY_USERS,
  }),
  saveSelectedMergeCompanyWorkers: (selectedWorkers: any) => ({
    type: ActionType.SAVE_SELECTED_MERGE_COMPANY_WORKERS,
    payload: { selectedWorkers },
  }),
  clearSelectedMergeCompanyWorkers: () => ({
    type: ActionType.CLEAR_SELECTED_MERGE_COMPANY_WORKERS,
  }),
  saveSelectedMergeCompanyInvoices: (selectedInvoices: any) => ({
    type: ActionType.SAVE_SELECTED_MERGE_COMPANY_INVOICES,
    payload: { selectedInvoices },
  }),
  clearSelectedMergeCompanyInvoices: () => ({
    type: ActionType.CLEAR_SELECTED_MERGE_COMPANY_INVOICES,
  }),
  fetchSelfClientStart: () => ({ type: ActionType.FETCH_SELF_COMPANY_START, payload: {} }),
  fetchOnboardingClientStart: (id: string) => ({ type: ActionType.FETCH_ONBOARDING_CLIENT_START, payload: { id } }),
  fetchSelfClientSuccess: (company: ClientModel.IClient) => ({ type: ActionType.FETCH_SELF_COMPANY_SUCCESS, payload: { company } }),
  fetchClientListStart: (query: GeneralModel.IQueryParams) => ({ type: ActionType.FETCH_CLIENT_LIST_START, payload: { query } }),
  fetchClientListSuccess: (list: Partial<ClientModel.IClient>[], count: number, hasMultipleEntries?: boolean) => ({
    type: ActionType.FETCH_CLIENT_LIST_SUCCESS,
    payload: { list, count, hasMultipleEntries },
  }),
  fetchOnboardingClientListSuccess: (list: Partial<ClientModel.IClient>[], count: number) => ({
    type: ActionType.FETCH_ONBOARDING_CLIENT_LIST_SUCCESS,
    payload: { list, count },
  }),
  fetchUserClientListStart: (id: string, query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_USER_CLIENT_LIST_START,
    payload: { id, query },
  }),
  fetchSubcontractorListStart: (query: GeneralModel.IQueryParams) => ({ type: ActionType.FETCH_SUBCONTRACTOR_LIST_START, payload: { query } }),
  fetchClientSummaryStart: (id: string, projectId?: string) => ({ type: ActionType.FETCH_CLIENT_SUMMARY_START, payload: { id, projectId } }),
  fetchClientDraftSummaryStart: (id: string, projectId?: string) => ({ type: ActionType.FETCH_CLIENT_DRAFT_SUMMARY_START, payload: { id, projectId } }),
  saveClientStart: (client: ClientModel.IClient, step: GeneralModel.IStep, redirect: boolean = true, uiRelationId?: string) => ({
    type: ActionType.SAVE_CLIENT_START,
    payload: { client, step, redirect, uiRelationId },
  }),
  inviteDraftClientStart: (client: ClientModel.IClient, hasInviteAsBranch: boolean = false) => ({
    type: ActionType.INVITE_DRAFT_CLIENT_START,
    payload: { client, hasInviteAsBranch },
  }),
  inviteDraftClientSuccess: (client: ClientModel.IClient) => ({ type: ActionType.INVITE_DRAFT_CLIENT_SUCCESS, payload: { client } }),
  sendApproveClientStart: (id: string) => ({ type: ActionType.SEND_FOR_APPROVE_CLIENT_START, payload: { id } }),
  sendApproveOnboardingClientStart: (id: string) => ({ type: ActionType.SEND_FOR_APPROVE_ONBOARDING_CLIENT_START, payload: { id } }),
  approveClientStart: (id: string) => ({ type: ActionType.APPROVE_CLIENT_START, payload: { id } }),
  approveOnboardingClientStart: (id: string) => ({ type: ActionType.APPROVE_ONBOARDING_CLIENT_START, payload: { id } }),
  updateDraftClientStart: (client: ClientModel.IClient) => ({ type: ActionType.UPDATE_DRAFT_CLIENT_START, payload: { client } }),
  updateDraftClientSuccess: (client: ClientModel.IClient) => ({ type: ActionType.UPDATE_DRAFT_CLIENT_SUCCESS, payload: { client } }),
  fetchMWbeListStart: () => ({ type: ActionType.FETCH_MWBE_START, payload: {} }),
  fetchMWbeListSuccess: (list: GeneralModel.INamedEntity[]) => ({ type: ActionType.FETCH_MWBE_SUCCESS, payload: { list } }),
  fetchTradesStart: () => ({ type: ActionType.FETCH_TRADES_START, payload: {} }),
  fetchTradesSuccess: (list: GeneralModel.INamedEntity[]) => ({ type: ActionType.FETCH_TRADES_SUCCESS, payload: { list } }),
  fetchProjectClientListStart: (id: string, query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_PROJECT_CLIENT_LIST_START,
    payload: { id, query },
  }),
  fetchProjectClientListSuccess: (projectId: string, list: Partial<ClientModel.IClient>[], count: number) => ({
    type: ActionType.FETCH_PROJECT_CLIENT_LIST_SUCCESS,
    payload: { projectId, list, count },
  }),
  fetchProjectClientHirearchyListStart: (id: string) => ({
    type: ActionType.FETCH_PROJECT_CLIENT_HIREARCHY_LIST_START,
    payload: { id },
  }),
  fetchProjectClientHirearchyListSuccess: (list: ClientModel.IHirearchyClientProject[]) => ({
    type: ActionType.FETCH_PROJECT_CLIENT_HIREARCHY_LIST_SUCCESS,
    payload: { list },
  }),
  searchClientStart: (query: GeneralModel.IQueryParams, uiRelationId?: string, isSecond?: boolean) => ({
    type: ActionType.SEARCH_CLIENT_START,
    payload: { query, uiRelationId, isSecond },
  }),
  searchInviteClientStart: (query: GeneralModel.IQueryParams) => ({ type: ActionType.FETCH_SEARCH_INVITE_CLIENT_START, payload: { query } }),
  searchInviteClientSuccess: (data: GeneralModel.IPagination<ClientModel.IClient>) => ({
    type: ActionType.FETCH_SEARCH_INVITE_CLIENT_SUCCESS,
    payload: { data },
  }),
  deleteClientStart: (id: string, query: GeneralModel.IQueryParams) => ({ type: ActionType.DELETE_CLIENT_START, payload: { id, query } }),
  deleteOnboardingClientStart: (id: string, query: GeneralModel.IQueryParams) => ({
    type: ActionType.DELETE_ONBOARDING_CLIENT_START,
    payload: { id, query },
  }),
  clearClientMap: () => ({ type: ActionType.CLEAR_CLIENT_MAP, payload: {} }),
  clearOnboardingClientMap: () => ({ type: ActionType.CLEAR_ONBOARDING_CLIENT_MAP, payload: {} }),
  updateClientStart: (client: ClientModel.IClient) => ({ type: ActionType.UPDATE_CLIENT_START, payload: { client } }),
  updateOnboardingClientStart: (client: ClientModel.IClient) => ({ type: ActionType.UPDATE_ONBOARDING_CLIENT_START, payload: { client } }),
  updateClientSuccess: (client: ClientModel.IClient, projectId?: string) => ({ type: ActionType.UPDATE_CLIENT_SUCCESS, payload: { client, projectId } }),
  updateOnboardingClientSuccess: (client: ClientModel.IClient) => ({ type: ActionType.UPDATE_ONBAORDING_CLIENT_SUCCESS, payload: { client } }),
  archiveClientStart: (id: string) => ({ type: ActionType.ARCHIVE_CLIENT_START, payload: { id } }),
  archiveClientSuccess: (id: string) => ({ type: ActionType.ARCHIVE_CLIENT_SUCCESS, payload: { id } }),
  unarchiveClientStart: (id: string) => ({ type: ActionType.UNARCHIVE_CLIENT_START, payload: { id } }),
  unarchiveClientSuccess: (id: string) => ({ type: ActionType.UNARCHIVE_CLIENT_SUCCESS, payload: { id } }),
  fetchProjectClientSummaryStart: (projectId: string, clientId: string) => ({
    type: ActionType.FETCH_PROJECT_CLIENT_SUMMARY_START,
    payload: { projectId, clientId },
  }),
  fetchProjectClientSummarySuccess: (projectId: string, client: ClientModel.IClient) => ({
    type: ActionType.FETCH_PROJECT_CLIENT_SUMMARY_SUCCESS,
    payload: { projectId, client },
  }),
  updateProjectClientTaxConditionStart: (projectId: string, taxCondition: ProjectNewModel.IClientTaxCondition) => ({
    type: ActionType.UPDATE_PROJECT_CLIENT_TAX_CONDITION_START,
    payload: { projectId, taxCondition },
  }),
  updateProjectClientTaxConditionSuccess: (projectId: string, clientId: string, condition: boolean) => ({
    type: ActionType.UPDATE_PROJECT_CLIENT_TAX_CONDITION_SUCCESS,
    payload: { projectId, clientId, condition },
  }),
  fetchAdminPermissionStart: (id: string) => ({ type: ActionType.FETCH_ADMIN_PERMISSION_START, payload: { id } }),
  fetchAdminPermissionSuccess: (isGeneralAdmin: boolean) => ({ type: ActionType.FETCH_ADMIN_PERMISSION_SUCCESS, payload: { isGeneralAdmin } }),
  updateWelcomeKitStart: (payload: { projectWelcomeKitRequests: { projectId: string; companyId: string }[] }) => ({
    type: ActionType.UPDATE_WELCOME_KIT_START,
    payload: payload,
  }),
  fetchProjectCompanyStart: (companyId: string, projectId: string) => ({
    type: ActionType.FETCH_PROJECT_COMPANY_START,
    payload: { companyId, projectId },
  }),
  fetchProjectCompanySuccess: (client: ClientModel.IClient) => ({
    type: ActionType.FETCH_PROJECT_COMPANY_SUCCESS,
    payload: { client },
  }),
  updateProjectCompanyStart: (client: ClientModel.IClient) => ({ type: ActionType.UPDATE_PROJECT_COMPANY_START, payload: { client } }),
  updateProjectCompanySuccess: (client: ClientModel.IClient, projectId?: string) => ({
    type: ActionType.UPDATE_PROJECT_COMPANY_SUCCESS,
    payload: { client, projectId },
  }),
  fetchJointVentureCompanyUsersStart: (companyId: string, query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_JOINT_VENTURE_COMPANY_USERS_START,
    payload: { companyId, query },
  }),
  fetchJointVentureCompanyUsersSuccess: (companyId: string, userList: IUser[]) => ({
    type: ActionType.FETCH_JOINT_VENTURE_COMPANY_USERS_SUCCESS,
    payload: { companyId, userList },
  }),
  assignClientProjectStart: (id: string, list: ProjectNewModel.IAssignClientProject[], sponsorId: string) => ({
    type: ActionType.ASSIGN_CLIENT_PROJECT_START,
    payload: { id, list, sponsorId },
  }),
  assignClientProjectSuccess: (list: ProjectNewModel.IAssignClientProject[]) => ({
    type: ActionType.ASSIGN_CLIENT_PROJECT_SUCCESS,
    payload: { list },
  }),
  fetchFailedTransactionsStart: (companyId: string) => ({
    type: ActionType.FETCH_FAILED_TRANSACTIONS_START,
    payload: { companyId },
  }),
  fetchFailedTransactionsSuccess: (failedTransactions: any) => ({
    type: ActionType.FETCH_FAILED_TRANSACTIONS_SUCCESS,
    payload: { failedTransactions },
  }),
  viewFailedTransactions: () => ({
    type: ActionType.VIEWED_FAILED_TRANSACTIONS,
    payload: {},
  }),
  fetchAllActiveClientsStart: (query: GeneralModel.IQueryParams) => ({ type: ActionType.FETCH_ALL_ACTIVE_CLIENTS_START, payload: { query } }),
  fetchAllActiveClientsSuccess: (clients: GeneralModel.INamedEntity[]) => ({ type: ActionType.FETCH_ALL_ACTIVE_CLIENTS_SUCCESS, payload: { clients } }),
  fetchClientListForMultipleProjectsStart: (query: GeneralModel.IQueryParams) => ({
    type: ActionType.FETCH_CLIENT_LIST_FOR_MULTIPLE_PROJECTS_START,
    payload: { query },
  }),
  fetchClientListForMultipleProjectsSuccess: (list: Partial<ClientModel.IClient>[]) => ({
    type: ActionType.FETCH_CLIENT_LIST_FOR_MULTIPLE_PROJECTS_SUCCESS,
    payload: { list },
  }),
  addUnverifiedCompaniesStart: (client: ClientModel.IUnverifiedClient) => ({
    type: ActionType.ADD_UNVERIFIED_COMPANIES_START,
    payload: { client },
  }),
  addUnverifiedCompaniesSuccess: (client: ClientModel.IClient) => ({ type: ActionType.ADD_UNVERIFIED_COMPANIES_SUCCESS, payload: { client } }),
  updateUnverifiedCompanySponsorStart: (clientId: string, projectId: string, sponsorId: string) => ({
    type: ActionType.UPDATE_UNVERIFIED_COMPANY_SPONSOR_START,
    payload: { clientId, projectId, sponsorId },
  }),
  updateUnverifiedCompanySponsorSuccess: () => ({ type: ActionType.UPDATE_UNVERIFIED_COMPANY_SPONSOR_SUCCESS, payload: {} }),
  updatePendingWelcomeClientNotesStart: (projectId: string, clientId: string, notes: string, queryParamsForFetchingList: any) => ({
    type: ActionType.UPDATE_PENDING_WELCOME_CLIENT_NOTES_START,
    payload: { projectId, clientId, notes, queryParamsForFetchingList },
  }),
};
